import React, { FunctionComponent, memo, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import NavigationBarIcon from '../../../Navigation/NavigationBar/Icon'
import { TestID } from '../../../utils/PropTypesDefinitions'
import { IconProps } from '../../../Navigation/NavigationBar/Icon/IconProps'

export type NavigationBarButtonProps = {
    /**
     * callback function triggered when NavigationBarButton is pressed
     *
     * @TJS-type function
     */
    onPress?: () => void
    minWidth?: number
    padding?: number
    size?: number
} & TestID &
    IconProps

const NavigationBarButton: FunctionComponent<NavigationBarButtonProps> = ({
    color,
    name,
    onPress,
    padding,
    minWidth,
    size,
    testID,
}): ReactElement => {
    const element = (
        <Grid noExpand center minHeight={44} paddingX={padding}>
            <NavigationBarIcon name={name} color={color} fontSize={size} />
        </Grid>
    )
    return (
        <Grid noExpand minWidth={minWidth || 44} testID={testID}>
            {onPress ? <Touchable onPress={onPress}>{element}</Touchable> : element}
        </Grid>
    )
}

export default memo(NavigationBarButton)
